import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Accordion } from '@quintype/em/components/accordion';
import { anonymousUsers } from './anonymous-users';
import { loggedInUsers } from './loggedIn-users';
import get from 'lodash/get';
import { richTxtFormats, richTxtModules } from '../../../constant';

function MeteringOn() {
  const formats = richTxtFormats;
  const modules = richTxtModules;

  const dispatch = useDispatch();
  const { meteredPaywall = {}, enableDarkModePreview = false } = useSelector(state =>
    get(state, ['builder', 'config'], {})
  );
  const { pageSetting = {} } = meteredPaywall;

  return (
    <div>
      <Accordion hasSingleActivePanel onToggle={() => {}}>
        {anonymousUsers(modules, formats, pageSetting, dispatch)}
        {loggedInUsers(modules, formats, pageSetting, dispatch)}
      </Accordion>
    </div>
  );
}

export default MeteringOn;
